export default function Cooktop() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10719_12265)">
                <path
                    d="M24.5 28H7.5C6.67157 28 6 27.3284 6 26.5V5.5C6 4.67157 6.67157 4 7.5 4H24.5C25.3284 4 26 4.67157 26 5.5V26.5C26 27.3284 25.3284 28 24.5 28Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6 22H26" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 25H23" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 8 26)" fill="black" />
                <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 26)" fill="black" />
                <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 14 26)" fill="black" />
                <circle cx="6" cy="6" r="6" transform="matrix(1 0 0 -1 10 19)" stroke="black" strokeWidth="1.5" />
            </g>
            <defs>
                <clipPath id="clip0_10719_12265">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
